// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2E5hT","actionsCol":"EnrolledClinics_actionsCol__2uLcG"};